var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isStatic)?_c('h1',[_vm._t("default")],2):_c('h1',_vm._l((_vm.text),function(text,i){return _c('div',{key:i,ref:'container_' + i,refInFor:true},[_c('i',[_vm._v(" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }